import { GET } from '../../store-helper';
import { BASE_URL } from '../../../../config/environmentConfig';
import { IDisputesAlertProviders } from '../payments-interfaces';
import {
  IDisputesAlertProvidersFiltersProps
} from '../../../components/disputes-alert-providers/DisputesAlertProvidersFilters';

export const fetchDisputesAlertProviders = async (parsedParams: IDisputesAlertProvidersFiltersProps): Promise<IDisputesAlertProviders[]> => {
  try {

    const { alertProviders } = await GET({
      pathname: `${BASE_URL.PAYMENTS}/alertProviders`,
      params: parsedParams
    });

    return alertProviders;

  } catch (e) {
    console.log('fetchDisputesAlertProviders error', e);
  }
};
